import React from 'react';
import { Control } from 'react-hook-form';
import { Row } from 'reactstrap';

import { IOrderModel, OrderDefinition } from 'models/Order';
import { OrderGridItem } from 'components';

interface Props {
  control: Control<IOrderModel, any>;
  definitions: OrderDefinition[];
  formIsReadOnly: boolean;
}

const OrderGrid: React.FC<Props> = ({ control, definitions, formIsReadOnly }) => {
  return (
    <Row>
      {definitions.map((definition) => (
        <OrderGridItem
          key={definition.fieldName}
          control={control}
          definition={definition}
          readOnly={formIsReadOnly}
        />
      ))}
    </Row>
  );
};

export default OrderGrid;
